import { render } from "./Terms.vue?vue&type=template&id=f946ae6c&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=f946ae6c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f946ae6c"

export default script